

class Coordinate {

	constructor(jsonData) {
		if (!jsonData)
			jsonData = {};

    	this.latitude = jsonData.latitude;
    	this.longitude = jsonData.longitude;
	}

}

const AreaType = {
	NODE: { 
		"code": 0,
		"name": "NODE",
		"creator": (jsonData) => { return new Node(jsonData); } 
	},
	getByName: (name) => {
		if (name === AreaType.NODE.name)
			return AreaType.NODE;
		else 
			return null;
		
	}

}

class Area {

  constructor(type) {
    if (this.constructor === Area) {
      throw new Error("Abstract classes can't be instantiated.");
    }

    this.type = type;
  }

}

class Node extends Area {

	constructor(jsonData) {
		super(AreaType.NODE.name);

		if (!jsonData)
			jsonData = {};

		this.coordinate = new Coordinate(jsonData.coordinate);
	}

}

export { AreaType, Coordinate, Node };